import ElTag from './src/tag';

/* istanbul ignore next */
ElTag.install = function(Vue) {
  Vue.component(ElTag.name, ElTag);
};

export default ElTag;



//////////////////
// WEBPACK FOOTER
// ./~/.1.4.12@element-ui/packages/tag/index.js
// module id = 12
// module chunks = 0